<div id="mySidebar" class="sidebar">
  <div class="">
    <div class="header-container">
      <div class="corporate-image">
        <img src="/assets/icons/logoweb_wh.svg" alt="Fernanbus" />
      </div>
      <a href="#" onclick="OpenLink('https://metgovalencia.com')" class="more-info">
        <span class="info-icon">+ info <i class="fas fa-external-link-alt"></i></span>
      </a>
    </div>
    <ty-menu *ngIf="!hideMenu"></ty-menu>
  </div>
  <div style="min-height: 70vh">
    <router-outlet></router-outlet>
  </div>

  <footer style="background-color: white" style="position: absolute; bottom: 0px;">
    <!-- <div style="bottom: 0; width: 350px; margin: 0 auto"> -->
    <!--<div style="position:relative; height: 32px; display: inline-flex; float: right">
      <img src="/assets/icons/logo-chip-softour.png" style="margin-right: 10px; height: 32px;" alt="" />
        <p style="padding-right: 5px"><span class="version">Versión {{ version }}</span></p>
      </div>
    -->
    <!-- </div> -->
  </footer>
</div>

<div id="main" class="main-container">
  <img
    class="openbtn open-button select-nav-button"
    (click)="openNav()"
    src="/assets/icons/luc-cuenca-ampliar-menu.svg"
    alt=""
  />
</div>

<!-- <div class="main-container simulate-container" *ngIf="isSimulateMode">
  <div class="simulate-panel">Modo Simulación</div>
</div> -->

<div class="map-wrapper">
  <div class="map-border">
    <div id="map" leaflet (leafletMapReady)="onMapReady($event)"></div>
  </div>
</div>
